<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <el-form :model="ruleForm" :rules="rules" class="backgroundForm" ref="ruleForm" label-width="120px">
          <el-form-item label="活动名称:" required >
          <el-input v-model="ruleForm.activityName" maxlength="15" show-word-limit placeholder="请输入活动名称" style="width: 340px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天 <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>

          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="isStartEdit"
              @change="handleActivityObj"
              style="margin-right: 16px"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~"
            >
              <el-button slot="reference" disabled>{{
                peopleList.length == 0
                  ? "选择人群"
                  : `已选${peopleList.length}个`
              }}</el-button>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #999;
                "
              >
                <span>新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="nowType == 'look' || (nowType == 'edit' && activityData.status == 2)"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="调查问卷主题:" required >
            <div style="width: 550px;padding: 8px;background: #F9FAFB;">
                <el-input
                  maxlength="200"
                  type="textarea"
                  class="textarea"
                  style="width: 484px"
                  resize="none"
                  v-model="ruleForm.questionDescription"
                  show-word-limit
                  :disabled="isStartEdit"
                ></el-input>
              </div>
          </el-form-item>

          <el-form-item label="设置题目:" required>
            <el-button  @click="openQuestionItem(-1)" :disabled="isStartEdit">添加题目</el-button>
            <!-- 题目卡 -->
            <div  
                v-for="(que, index) in queItems"
                :key="index"
                style="margin: 20px 0;">
              <el-card class="box-card" style="display: inline-block;width:800px">
                <div slot="header" class="clearfix boxCard-header">
                  <div style="font-size: 16px;">
                    <span>{{'题目'+ (index+1) + ' : ' }}</span>
                    <span v-if="que.type == 1">单选题</span>
                    <span v-if="que.type == 2">多选题</span>
                    <span v-if="que.type == 3">填空题</span>
                    <span v-if="que.type == 4">图片选择题</span>
                    <span v-if="que.type == 5">图片上传题</span>
                  </div>
                  <!-- 操作按钮组 -->
                  <div style="float: right; padding: 3px 0">
                    <el-button :disabled="isStartEdit" class="btnCard" @click="clickUp(index)" v-if="index !== 0" >上移</el-button>
                    <el-button :disabled="isStartEdit" class="btnCard" @click="clickDown(index)" v-if=" queItems && index !== (queItems.length -1)">下移</el-button>
                    <el-button :disabled="isStartEdit" class="btnCard" @click="openQuestionItem(index)">编辑</el-button>
                    <el-button :disabled="isStartEdit" class="btnCard" @click="delectQueItem(index)">删除</el-button>
                  </div>
                </div>
                <div>
                   <div>
                      <span class="cardTitle">是否必填：</span>
                      <span v-if="que.isMust == 1">必填</span>
                      <span v-if="que.isMust == 0">非必填</span>
                   </div>
                   <div>
                      <span class="cardTitle">题目：</span>
                      <span>{{que.title}}</span>
                   </div>
                   <span class="cardTitle"  v-if="que.type == 1 || que.type == 2 || que.type == 4">选项：</span>
                   <div v-if="que.type == 1 || que.type == 2" >
                      <div v-for="(item,index) in que.options" :key="index">
                        <span v-if="index == 0">A、</span >
                        <span v-if="index == 1">B、</span>
                        <span v-if="index == 2">C、</span>
                        <span v-if="index == 3">D、</span>
                        <span v-if="index == 4">E、</span>
                        <span v-if="index == 5">F、</span>
                        {{ item.description }}<span style="margin-left:10px" v-if="que.type == 1 && item.isInputText==1">(选中需输入不少于{{ item.inputTextLimit }}个字信息)</span>
                      </div>
                   </div>
                   <div v-if="que.type == 4" style="display:flex;margin: 0 20px;">
                      <div v-for="(item,index) in que.options" :key="index">
                        <div style="display: flex;margin: 0 10px ;">
                          <span v-if="index == 0">A、</span >
                          <span v-if="index == 1">B、</span>
                          <span v-if="index == 2">C、</span>
                          <span v-if="index == 3">D、</span>
                          <span v-if="index == 4">E、</span>
                          <span v-if="index == 5">F、</span>
                          <img  :src="item.picUrl" class="imgItem" />
                        </div>
                      </div>
                   </div>
                   <div v-if="que.type == 3">
                      <span class="cardTitle">字数限制：</span>
                      <span>不少于 {{ que.textLimit }} 个字</span>
                   </div>
                   <div v-if="que.type == 5">
                      <span class="cardTitle">上传张数：</span>
                      <span>不少于 {{ que.picLimit }} 张，最多5张</span>
                   </div>
                </div>
              </el-card>
            </div>
            
          </el-form-item>
        
          <el-form-item label="奖品设置:"  required>
            <el-button @click="centerVis" :disabled="isStartEdit">选择奖品</el-button>
            <div class="theLag" v-if="isShowPrizeType">
              <div class="theBox">
                  <div
                    v-if="prizeSettingList.prizeType == 4"
                    style="margin: 30px 0 15px 0; width: 280px;display:flex;justify-content: center;"
                  >
                    <p class="discount_sty">
                      {{ prizeSettingList.prizeTxt? prizeSettingList.prizeTxt: prizeSettingList.price }}
                    </p>
                    <div style="height:44px; width:1px;background:#FE4D45;opacity:0.2;margin:0 12px"></div>
                    <div style="color:#999999">
                      <p v-if="prizeSettingList.prizeType == 4">店铺积分</p>
                    </div>
                  </div>
                  <div
                    v-else-if="prizeSettingList.prizeType == 1"
                    style="margin: 30px 0 15px 0; width: 280px;display:flex;justify-content: center;">
                    <div class="discount_sty">
                      {{ prizeSettingList.price }}<span>元</span>
                    </div>
                    <div
                      style="height:44px; width:1px;background:#FE4D45;opacity: .2;margin:0 12px"
                    ></div>
                    <div style="color:#999999">
                      <span class="p" v-if="prizeSettingList.prizeType == 1">优惠券</span>
                    </div>
                  </div>
                  <p
                    v-else
                    style="margin: 30px 0 25px 0; padding-left: 25px; width: 280px; text-align: center; text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis;display: -webkit-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical;"
                  >
                    {{ prizeSettingList.title }}
                  </p>
                  <p style="text-align: center;padding-top: 5px" v-if="prizeSettingList.prizeType == 1">优惠券</p>
                  <p style="text-align: center;padding-top: 5px" v-if="prizeSettingList.prizeType == 4">店铺积分</p>
                  <p style="text-align: center;padding-top: 5px" v-if="prizeSettingList.prizeType == 3">实物</p>
                </div>
              <div class="backgrd"></div>
              <el-button  :disabled="isStartEdit" class="btnQx" type="primary" @click="deleteCoupon">删除</el-button>
            </div>
          </el-form-item>

          <el-form-item label="奖品份数:"  required>
            共赠送
            <el-input 
            v-model="ruleForm.prizeCount" 
            placeholder="请输入" 
            @blur="beAdd()" 
            @input="ruleForm.prizeCount = getNumberData($event, 0)" style="width: 70px"> </el-input>
            份奖品，每人每次限领一份奖品，先到先得
          </el-form-item>

          <el-form-item label="曝光商品:"  class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px 10px 0px 10px;"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>

          <el-form-item label="活动规则:" required>
            <div
              style="width: 550px;
              padding: 8px;
              background: #F9FAFB;
              position: relative;"
            >
            <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :disabled="backgroundOpacity"
              ></el-input>

              <div>
                <el-button type="primary" class="generate" plain @click="generateRule" :disabled="backgroundOpacity">生成规则</el-button>
                <span class="desc">
                  <i class="el-alert__icon el-icon-info" style="color:#999"></i>
                  点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示。
                </span>
              </div>
            </div>
          </el-form-item>

          <div v-if="backgroundOpacity" class="backgroundOpacity" style="height: calc(100% - 45px);"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button  class="createBtn create_bottom_returnBtn" size="medium" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
    </div>
    <!-- 添加题目弹窗 -->
    <questionItem @close="closeQueItem" @choose-question="getQueData" 
    :queForm="queItem" :isShow="isShowQue" v-if="isShowQue"
    :isEdit="isEdit"
    ></questionItem>
    
    <!-- 选择奖品弹窗 -->
    <selectProduct @close="colseDialog" 
    :hide ='1'
    :num="1" 
    :JingdouCount="JingdouCount" 
    v-if="showDialog" 
    ref="selectProduct" 
    @choose-shop="getTheData"
    ></selectProduct>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchfocusStores } from "@/api/integralCenter/integralTask";
import selectProduct from "./select_prize&integral";

import { getActivity, saveOrUpdate } from "@/api/integralCenter/questionSet";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import questionItem from "@/components/querstionItem";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    questionItem
  },
  data() {
    return {
      isStartEditTime:'',
      isStartEdit:false,
      valueRow: null,
      isCopy: false,
      activityData: {
        id: 132,
      },
      activeValue: null,
      backgroundOpacity: false,
      isSave: true,
      navList: [],
      tabActive: 0,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      fromLoading: false, // 数据加载 显示

      JingdouCount: {
        prizeCount: 0,
      },
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      isShowPrizeType:false,

      levelList: [],
      disableTime: false,
      clickActual: false,
      showDialog: false,
      momentValue: {}, //编辑回显
      isShow: false,

      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      questionDescription:"",//问卷主题
      isShowQue:false,//控制问题弹窗开关
      isEdit:false,//控制编辑还是增加
      queItems:[],//题目组
      questionForm:{ //问卷默认内容
        type: 1,//默认单选1
        title:"",
        isMust:1,//默认必填
        options: [ //选项默认3个
          // {description: '',picUrl:'',loading:false},
          // {description: '',picUrl:'',loading:false},
          // {description: '',picUrl:'',loading:false},
          { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
          { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
          { description: '', picUrl: '', loading: false, isInputText: 0, inputTextLimit: '' },
        ],
        textLimit:'',//填空题字数限制
        picLimit:1,//图片上传张数限制
      },
      queItem:{},
      ruleForm: {
        membershipTime:"",
        //设置规则表单
        activityName: "",//活动名称
        startTime: "",
        endTime:"",
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        activityObject: 0,
        newOldCustomer: 0,
        partner: ["-1"],
        activityRulesText: "", //生成规则

        exposureSwitch: false, // 是否添加曝光商品
        itemList: [], // 曝光商品集合

        questionDescription:"", // 调查问卷主题

        prizeCount:"",//奖品份数

      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        questionDescription: [
          { required: true, message: "请填写调查问卷主题", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        prizeSettingList: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
      },
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
      isShowSelectCrowd: false,
      peopleList: [],
    };
  },
  async created() {
    this.activityData = this.$route.query.activityData;
    this.queItem=this.questionForm;
    console.log('this.$route.query------>', this.$route.query)
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
        this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
        this.$route.query.statusComment == "true" ? true : false;
        this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.typeDetail();
    } else if (this.$route.query.copyParams) { // 复制
      this.isCopy = true
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.typeDetail();
    } else {
      this.activityTimeChange();
    }
    this.getLevel();
    console.log('this.activeValue55555------>', this.activeValue)
  },
  mounted() {
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    //回显
    typeDetail() {
      //关注店铺有礼
      getActivity(this.valueRow.id)
        .then((res) => {
          let datas, change1, change2, days, daysStart, daysEnd, date3;
          daysStart = res.data.startTime.substring(0, 10);
          daysEnd = res.data.endTime.substring(0, 10);
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(res.data.endTime).getTime() -
            new Date(res.data.startTime).getTime();
          let leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          this.activityTimeValue = [
            String(res.data.startTime),
            String(res.data.endTime),
          ];
          if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);

          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? res.data.newOldCustomer
            : 0;
          this.peopleList =
            res.data.hasOwnProperty("seniorGroupId") &&
            res.data.seniorGroupId.length > 0
              ? res.data.seniorGroupId.split(",")
              : [];

          this.ruleForm.partner = res.data.allowLevel.split(",");

          this.ruleForm.activityRulesText = this.isCopy ? "" : String(res.data.ruleDescription); //生成规则
        
          //问卷内容
          this.ruleForm.questionDescription = res.data.ruleDTO.theme
          this.queItems = res.data.ruleDTO.questions

          //奖品处理
          if (!this.isCopy) {
            this.tableData = res.data.pointActivityPrizeDTOList.map((item) => {
              let obj = {
                id:item.id,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                logo: item.logo,
                discount: item.price || item.singleAmount,
                singleAmount: item.singleAmount,
                price: item.price,
                prizeCount: item.totalAmount,
              };
              if (item.prizeType == 1) {
                obj.quota = item.quota;
                obj.couponType = item.couponType;
                if(item.couponType == 4) {
                  obj.batchKey = item.batchKey
                  obj.assetsId = null
                }
              }
              this.prizeSettingList = obj
              this.ruleForm.prizeCount = item.totalAmount
              this.minNum = item.totalAmount
              this.isShowPrizeType=true
              return obj;
            });
          } else {
            this.prizeSettingList = {
              price: null,
              title: "",
              assetsId: null,
              prizeType: null,
              logo: "",
              discount: "",
              singleAmount: "",
            }
            this.tableData = [
              {
                peopleCount: "",
                prizeType: "",
                discount: "",
                price: "",
                prizeCount: "",
                singleAmount: "",
              },
            ]
            this.ruleForm.prizeCount = ""
          }
          
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          console.log(this.ruleForm.exposureSwitch);
          // 商品处理
          let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
                return {
                  ...item,
                  numIid: item.wareId,
                  itemTitle: item.title,
                  picUrl: item.logo,
                };
              })
            : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
          this.itemListFor = shopList;
          
          this.activityTimeChange();
        })
        .catch(() => {});
    },

    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },

    
    // 活动进行中修改奖品数量
    beAdd(){
      console.log("活动进行中修改奖品数量",this.minNum,this.ruleForm.prizeCount);
      if(this.isStartEdit){
        if(this.minNum && Number(this.ruleForm.prizeCount) < Number(this.minNum)){
          this.ruleForm.prizeCount= this.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },

    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
      this.tableData=[
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ]
      this.isShowPrizeType = false
    },

    //选择奖品弹窗
    centerVis() {
      this.generalCoupon = { couponType: 0 }
      this.JingdouCount.prizeCount = this.ruleForm.prizeCount;
      if (this.isCumulativePrize) {
        this.JingdouCount = this.tableData[this.tableIndex];
      } else {
        this.JingdouCount = this.prizeSettingList;
      }

      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        this.$refs.selectProduct.physicalGift(this.JingdouCount)
      });
    },

    //选择奖品数据
    getTheData(data, prizeType) {
        console.log(data, prizeType, "data");
        this.prizeSettingList = {}
        if(data.couponType == 4) {
          this.generalCoupon = JSON.parse(JSON.stringify(data))
        } else {
          this.generalCoupon = { couponType: 0 }
        }
        this.showDialog = false;
        
        if(data.couponType == 4) {
          if(!data.price || !data.batchKey || !data.couponType){
            this.$message.warning("请填写完整的优惠券信息");
            return
          }
          this.prizeSettingList.singleAmount = 1;
          this.prizeSettingList.assetsId = null;
          this.prizeSettingList.prizeType = prizeType;
          this.prizeSettingList.title = "优惠券";
          this.prizeSettingList.price = data.price;
          this.prizeSettingList.batchKey = data.batchKey;
          this.prizeSettingList.couponType = data.couponType;
        } else {
          this.prizeSettingList.singleAmount = Number(data.price)|| 1;
          this.prizeSettingList.assetsId = Number(data.couponId);
          this.prizeSettingList.prizeType = prizeType;
          this.prizeSettingList.logo = data.logo;
          this.prizeSettingList.title = data.name || prizeType;
          this.prizeSettingList.price = data.discount || data.price;
        }
        if(prizeType == 1) {
          if(data.couponType == 4) {
            this.prizeSettingList.couponType = 4;
          } else {
            this.prizeSettingList.couponType = 3;
          }
        }
        if (prizeType == 4) {
          if(!data.discount){
            this.$message.warning("店铺积分不能为空");
            return
          }
          this.prizeSettingList.title = data.discount+"店铺积分";
          this.prizeSettingList.price = data.discount;
          this.prizeSettingList.singleAmount = data.singleAmount;
        } else if (prizeType == 2) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = prizeType;
          this.prizeSettingList.quantityTotal = data.quantityTotal;
        } else if (prizeType == 10) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = data.itemTitle;
          this.prizeSettingList.quantityTotal = data.quantityTotal;
          this.prizeSettingList.assetsId = data.id;
          this.prizeSettingList.logo = data.picUrl;
        }else if(prizeType == 3) {
          this.prizeSettingList.title = data.name;
          this.prizeSettingList.price = data.discount;
          // this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.type = data.couponId ? 2 : 1; // 实物类型：1普通上传图片实物 2普通实物 3专属下单实物
          this.prizeSettingList.prizeId = data.couponId; //普通实物传skuId，专属下单实物传id
          this.prizeSettingList.logo = data.logo;
        }
        this.getTheData2(data, prizeType)
        this.setPrizeTxt(this.prizeSettingList);
    },
      //选择商品数据 曝光
    getTheData2(data, prizeType) {
      this.tableData[0].prizeType = prizeType;
      this.tableData[0].price = data.discount || data.singleAmount;
      this.tableData[0].singleAmount = data.singleAmount;
      this.tableData[0].title = data.name || prizeType;
      this.tableData[0].assetsId = Number(data.couponId);
      this.tableData[0].logo = data.logo;
      if (prizeType == 1) {
        this.tableData[0].quota = data.quota;
        this.tableData[0].couponType = data.couponType;
        if(data.couponType == 4) {
          this.tableData[0].prizeType = prizeType;
          this.tableData[0].price = data.price;
          this.tableData[0].singleAmount = data.singleAmount;
          this.tableData[0].price = data.price;
          this.tableData[0].assetsId = null;
          this.tableData[0].batchKey = data.batchKey;
        }
      }
      if (prizeType == 2) {
        this.tableData[0].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 10) {
        this.tableData[0].price = data.price;
        this.tableData[0].assetsId = data.id;
        this.tableData[0].logo = data.picUrl;
        this.tableData[0].title = data.itemTitle;
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        if (item.couponType == 4) {
          item.prizeTxt = item.price;
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
      if(this.prizeSettingList.prizeType){
        this.isShowPrizeType=true
      }
    },

    // 弹框确认
    handleDialogCloseAnoth() {
      console.log("this.tableData-----------",this.tableData)
      console.log("this.queItems-----------",this.queItems)
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      //对象排序(根据对象的某一属性)
      // if (this.draggingId.length != []) {
      //   let a = this.draggingId;
      //   let b = [];
      //   for (let i = 0; i < a.length; i++) {
      //     this.itemListFor.find((obj) => {
      //       if (obj.skuId == a[i]) {
      //         b.push({
      //           logo: obj.logo,
      //           price: obj.price,
      //           title: obj.title,
      //           skuId: obj.skuId,
      //           wareId: obj.numIid,
      //         });
      //       }
      //     });
      //   }
      //    obj.itemList = b;
      // }
      //活动名称的限制
      if (!this.ruleForm.activityName ||this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if(!this.ruleForm.questionDescription ||this.ruleForm.questionDescription.length == 0){
        this.$message.warning("请设置调查问卷主题");
        return;
      }

      //问卷题目的限制
      if (! this.queItems ||this.queItems.length == 0) {
        this.$message.warning("请设置调查问卷题目");
        return;
      }

      // 请将奖品填写完整！
      let isFlay = false;
      // console.log('tableData>>',this.tableData)
      this.tableData.forEach((item) => {
        if (!item.price || !item.title) {
          isFlay = true;
        }
      });
      if (!this.tableData || isFlay) {
        this.$message.warning("请选择奖品")
        return;
      }

      if(!this.ruleForm.prizeCount){
        this.$message.warning("请输入奖品份数");
        return;
      }

      let _itemList=[]
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if(this.mainImagelist.length === 0){
          this.$message.warning("请添加曝光商品！");
          return;
        }else{
          _itemList=this.mainImagelist.map((item) => {
              return {
                logo: item.logo,
                price: item.price,
                title: item.title,
                skuId: item.skuId,
                wareId: item.numIid,
              };
          })
        }
      }


      if (!this.ruleForm.activityRulesText) {
        this.$message.warning("活动规则不能为空");
        return;
      }


      //判断勾选提示后即可调取接口
      if (this.checked == true) {
      let {activityName,startTime,endTime,activityRulesText,questionDescription,exposureSwitch,prizeCount} = this.ruleForm;
      let obj = {
          activityName:activityName,
          startTime:startTime,
          endTime:endTime,
          activityObject: this.ruleForm.activityObject,
          membershipTime:this.ruleForm.membershipTime,
          newOldCustomer: this.ruleForm.newOldCustomer,
          seniorGroupId: this.peopleList.join(","),
          allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
          ruleDescription : activityRulesText,
          isExposureItem: exposureSwitch ? 1 : 0,
          ruleDTO: {
            theme:questionDescription,
            questions : this.queItems
          },
          pointActivityPrizeDTOList:this.tableData.map((item) => {
              let prize = {
                id:item.id,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount, //
                totalAmount: prizeCount, // 总数额
                price: item.price,
              };
              if (prize.prizeType == 3 || prize.prizeType == 10) {
                prize.logo = item.logo;
              }
              if (prize.prizeType == 1) {
                prize.quota = item.quota;
                prize.couponType = item.couponType;
                if(item.couponType == 4) {
                  prize.batchKey = item.batchKey
                }
              }
              return prize;
            }),
            itemList: _itemList
        };

        if (this.valueRow && !this.isCopy) {
          console.log("保存修改")
          saveOrUpdate({ ...obj, id: this.valueRow.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          saveOrUpdate(obj).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({ path: "activeList1" });
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },

    //删除
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
      console.log(this.mainImagelist, 4444444);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
      console.log("this.mainImagelist)", arr);
    },

    //活动时间驱动
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days < 3 && !this.backgroundOpacity) {
          this.$message.warning("活动间隔最少为3天！");
          this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = null;
          this.timeOut = 0;
          this.timeDay = 0;
          return;
        }

        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        } else {
          this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
      }
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 下一步
    saveEdit() {
      console.log("进来验证111")
      this.$refs.ruleForm.validate((valid) => {
        console.log("进来验证")
        if (valid) {
          this.joinBlackList = true;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    //添加题目弹窗
    openQuestionItem(index){
      if(this.isStartEdit) return;
      this.queNum = index
      if(index === -1 ){
        this.isEdit = false
        this.queItem = this.questionForm
        console.log("添加",this.queItem)
      }else{
        this.isEdit = true
        this.queItem = this.queItems[index]
        console.log("编辑",this.queItem)
      }
      this.isShowQue=true
    },  
    closeQueItem(){
      this.isShowQue=false
    },
    //获取题目数据
    getQueData(data){
      let index = this.queNum
      if( index === -1 ){
        //新增
        this.queItems.push(data)
        console.log("添加后",data)
      }else{
        //编辑
        this.queItems[index]=data
        console.log("编辑",data)
      }
      console.log("题目组",this.queItems)
    },
    //点击上移
    clickUp(index){
      if(this.isStartEdit) return;
      if(index === 0){
        this.$message.warning("第一个无法上移");
      }else{
        this.swapArray(this.queItems, index-1, index);
      }
    },
    //点击下移
    clickDown(index){
      if(this.isStartEdit) return;
      let _length =this.queItems.length -1
      if(index === _length){
        this.$message.warning("最后一个无法下移");
      }else{
        this.swapArray(this.queItems, index, index+1);
      }
    },
    //数组元素互换位置
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    },
    // 删除题目
    delectQueItem(index){
      if(this.isStartEdit) return;
      this.queItems.splice(index, 1)
    },
    //生成规则
    generateRule() {
      let oldValue = this.ruleForm;
      let text1 = "",
          text2 = "",
          text3 = "填写问卷获得奖励，先到先得",
          text4 = "活动期内只能填写一次问卷",
          text5 = "一旦发现活动参与者有使用脚本作弊、一人使用多个账户等违规及不正当行为，活动方有权取消该用户参与活动的资格，并冻结或取消已发放的奖励。对情况恶劣者，活动方有权取消相关用户在平台参与奖励服务的资格。任何存在使用物联网卡或未实名卡，或使用被任何平台或者第三方认定为或标记为黑产囤积号码、诈骗号码、羊毛党号码、异常号段号码、非实名用户等情形的用户，将被认定为非正常用户。一旦认定为非正常用户活动方有权取消该用户的全部活动奖品/奖励，并保留追究法律责任的权利",
          text6 = "活动最终解释权归店铺所有";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 = "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      //参与对象
      let text7 = "";
      if (
        this.ruleForm.activityObject == "1" &&
        this.ruleForm.partner.length > 0
      ) {
        let levelText = [];
        this.ruleForm.partner.forEach((item) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });

        text7 = "活动参与对象：" + levelText.splice(",");
      } else {
        text7 = "活动参与对象：全部";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }

      let Arr1 = [text1, text2, text7,text34, text3, text4, text5, text6];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 返回
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch(() => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  // min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 24px;

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
  }
}
.box-card{
    .boxCard-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btnCard{
        color: rgb(38, 112, 251);
        padding: 0 0 0 10px;
        cursor: pointer;
        width: 50px;
      }
    }
    .cardTitle{
      font-weight: bold;
    }
    .imgItem{
      width: 80px;
      height: 80px;
      display: block;
    }
}
.theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        // border: 1px solid #999;
        background: url("../../assets/thdImg/pages/yhq.svg") no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        margin-bottom: 10px;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 20px;
          width: 120px;
          text-align: right;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
          padding-top: 10px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 100%;
          height: 100%;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }
</style>
